<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddBeneficiary">
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_name1')" v-model="formParams.b_name1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_descript1')" v-model="formParams.b_descript1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('first_name1')" v-model="formParams.first_name1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('last_name1')" v-model="formParams.last_name1" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="countries.length>0">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select country"
              autocomplete
              class="selectExample w-full"
              label="Country"
              v-model="formParams.country"
              >
              <vs-select-item :key="index" :value="item.country" :text="item.country" v-for="(item,index) in countries" />
          </vs-select>
          </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_address1')" v-model="formParams.b_address1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_phone1')" v-model="formParams.b_phone1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_email1')" v-model="formParams.b_email1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_skype1')" v-model="formParams.b_skype1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_telegram1')" v-model="formParams.b_telegram1" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('b_url1')" v-model="formParams.b_url1" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="addBeneficiary()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {
          countries: []
        }
    },
    watch: {
    'popUps.popupAddBeneficiary'(val) {
      if(val===true && this.countries.length===0)
        this.getCountries();
      }
    },
    methods:{
      getCountries: function(){
        let that = this;
        this.$vs.loading();
        axios.get("https://crm.evblock.com/api/lists?countries")
        .then((response) => {
          that.$vs.loading.close();
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.countries.push(obj);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      addBeneficiary: function(){
        let that = this;
        this.$vs.loading();
        axios.post("https://crm.evblock.com/api/beneficiary",this.formParams)
        .then((response) => {
          that.$vs.loading.close();
          if(response.data[0].out1=='done!'){
            that.closePopups();
            that.openAlert('success','Success');
            that.componentKey++;
          } else{
             that.openAlert('danger','Failed',response.data[0].out1);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      translate: function(key){
        return this.$t(key);
      },      
    }
}
</script>